import React, { Component, PropTypes } from 'react';
import LoadingBar from 'react-redux-loading-bar';
import { Link } from 'react-router';
import _ from 'lodash';


class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: false
        };
    }

    componentWillMount() {
        let { children } = this.props,
            children_array = (_.isArray(children)) ? children : [children]
        ;

        let display = _.filter(children_array, (link) => {
                return link.props.display;
            }).length > 0
        ;

        this.setState({
            display: display
        });
    }

    renderLoadingBar() {
        return (
            <div className="loading-bar">
                <LoadingBar style={styles.loadingBarStyle} />
            </div>
        );
    }

    renderBrand() {
        return (
            <Link
                to="/"
                className="navbar-brand"
            >
                TigerFile
            </Link>
        );
    }

    renderToggler() {
        return (
            <button
                className="navbar-toggler navbar-toggler-right"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon">&nbsp;</span>
            </button>
        );
    }

    render() {
        const { children, className, showBrand, useLoadingBar, useToggler, collapse } = this.props,
            children_array = (_.isArray(children)) ? children : [children]
        ;

        return (
            this.state && this.state.display
            ? (
                <div>
                    <nav
                        className={className}>
                        {useToggler ? this.renderToggler() : null}
                        {showBrand ? this.renderBrand() : null}
                        <div
                            className={(collapse ? 'collapse': '') + " navbar-collapse"}
                            id="navbarSupportedContent"
                        >
                            <ul className="navbar-nav mr-auto">
                                {
                                    _.map(children_array, (link) => {
                                        if (link && link.props && link.props.side === 'left' && link.props.display) {
                                            return link;
                                        }
                                    })
                                }
                            </ul>
                            <ul className="navbar-nav">
                                {
                                    _.map(children_array, (link) => {
                                        if (link && link.props && link.props.side === 'right' && link.props.display) {
                                            return link;
                                        }
                                    })
                                }
                            </ul>
                        </div>
                    </nav>
                    {useLoadingBar ? this.renderLoadingBar() : null}
                </div>
            ) : null
        );
    }
}

const styles = {
    loadingBarStyle: {
        backgroundColor: '#ff8f00',
        height: '5px',
        zIndex: '99999'
    }
};

NavBar.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    collapse: PropTypes.bool,
    display: PropTypes.bool,
    useLoadingBar: PropTypes.bool,
    useToggler: PropTypes.bool,
    showBrand: PropTypes.bool
};

export default NavBar;



/** WEBPACK FOOTER **
 ** ./src/components/NavBar.js
 **/